import React from 'react';
import ReactDOM from 'react-dom/client';
import { ReviewTermsPage } from './ReviewTerms';
import '~/styles/main.scss';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ReviewTermsPage />
  </React.StrictMode>
);
